<!--
This file is part of the project: "Digiziege"
An app for animal-welfare-oriented goat husbandry and contactless weight estimation.
GitLab: https://gitlab.rlp.net/proj-wise2526-digiziege/digiziege

Copyright (c) 2026 Digiziege Team TH-Bingen

Description:
Companion app for welfare-oriented goat husbandry featuring contactless weight estimation via camera,
master data management and health tracking.
Built as a PWA with a local-first approach to ensure data privacy.

LICENSE INFORMATION:
This program is free software: you can redistribute it and/or modify it under the terms of the
GNU Affero General Public License as published by the Free Software Foundation,
either version 3 of the License, or (at your option) any later version.

This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
See the GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License along with this program.
If not, see <https://www.gnu.org/licenses/>.
-->

<template>
  <EditGeneralInfoFormModule v-if="goat" :goat="goat" @save="save" />
</template>

<script setup>
  import EditGeneralInfoFormModule from './EditGeneralInfoForm.vue'
  import { useGoatStore } from '@/stores/goat.store.js'

  const goatStore = useGoatStore()

  const emit = defineEmits(['saved'])

  const props = defineProps({
    goat: { type: Object, default: null },
  })

  async function save(data) {
    if (!props.goat) return
    await goatStore.updateGoat(props.goat.id, data)
    emit('saved')
  }
</script>
